module.exports = __webpack_public_path__ + "963f6f684e64430cbbb6fa419322f471.svg";